import {
  ApiResponse,
  TradeInDiscountGrouped,
  CreateDiscount,
  TokenData,
  TradeInDiscount,
  OtpResponse,
  CreateDiscountLimits,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class TradeInDiscountService extends ApiService {
  public async loadTradeInDiscountType() {
    const url = `${this.apiDomain}/api/discount/tradeIn`;

    const resposne = await http.get<ApiResponse<TradeInDiscountGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDiscount(data: CreateDiscount) {
    const url = `${this.apiDomain}/api/discount/tradeIn`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async updateDiscount(id: string, data: CreateDiscount) {
    const url = `${this.apiDomain}/api/discount/tradeIn/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async getTradeInDiscount(id: string) {
    const url = `${this.apiDomain}/api/discount/tradeIn/${id}`;

    const resposne = await http.get<ApiResponse<TradeInDiscount>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async requestOtp(purpose?: string) {
    const url = `${this.apiDomain}/api/otp/request`;

    const response = await http.post<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
      },
      this.store
    );
    return response.data;
  }
  public async reSendOtp(id?: string, purpose?: string) {
    const url = `${this.apiDomain}/api/otp/${id}/resend`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
      },
      this.store
    );
    return response.data;
  }

  public async updateTradeInDiscountLimits(
    data?: CreateDiscountLimits,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/tradeIn/${id}/limits`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async cloneDiscount(data: CreateDiscount, id?: string) {
    const url = `${this.apiDomain}/api/discount/tradeIn/${id}/clone`;

    const response = await http.post<ApiResponse<TradeInDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data?.data;
  }
  public async deleteDiscount(id?: string) {
    const url = `${this.apiDomain}/api/discount/tradeIn/${id}`;
    const response = await http.remove<ApiResponse<TokenData>>(url, this.store);
    return response.data;
  }
}
